import { orderBy } from 'lodash-es'

import { AdminDate } from '@/components/shared/AdminDate'
import { AdminSection } from '@/components/shared/AdminSection'
import { AdminTable } from '@/components/shared/AdminTable'
import { AdminTooltip } from '@/components/shared/AdminTooltip'

import type { LoadPanelProps } from './types'

export const NotesPanel = ({ load }: LoadPanelProps) => {
  return (
    <AdminSection className="" title="Notes">
      <AdminTable
        data={load.notes}
        rowKey={r => r._id}
        columns={[
          {
            key: 'createdDate',
            label: 'Created',
            render: d => <AdminDate val={d.createdDate} />,
          },
          {
            key: 'message',
            label: 'Message',
            render: d => (
              <AdminTooltip
                label={
                  <div className="max-w-xl whitespace-pre-wrap break-words">
                    {d.message}
                  </div>
                }
              >
                <span className="block max-w-[700px] truncate">
                  {d.message}
                </span>
              </AdminTooltip>
            ),
          },
          { key: 'source', label: 'Source', render: d => d.source },
          { key: 'type', label: 'Type', render: d => d.type },
          {
            key: 'user',
            label: 'User',
            render: d => d.createdBy?.name,
            sort: (data, dir) => orderBy(data, d => d.createdBy?.name, [dir]),
          },
        ]}
      />
    </AdminSection>
  )
}
